<px-m0240-audio-player
    [headline]='content.headline'
    [text]='content.text'
    [image]='content.image'
    [file]='content.mp3'
>
</px-m0240-audio-player>
